import { gql } from 'graphql-request'

export const CREATE_USER_TAG_CLICK = gql`
  mutation CreateUserTagClick($input: CreateUserTagClickInput!) {
    createUserTagClick(input: $input) {
      status
    }
  }
`
